import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const ChatSkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        flex: 1,
        flexDirection:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? "column"
            : "row",
      }}
    >
      <View
        style={{
          flex:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 1
              : 0.5,
          marginLeft:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 0
              : 20,
          marginVertical: 15,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "100%"
              : 406,
        }}
      >
        <Skeletons
          height={500}
          width={"100%"}
          style={{
            marginRight: 10,
            borderRadius: 10,
          }}
        />
      </View>

      {deviceSize === DEVICE_SIZES.SM ||
      deviceSize === DEVICE_SIZES.XS ? null : (
        <View
          style={{
            flex: 1,
            marginLeft: 20,
            marginVertical: 15,
            width: 780,
          }}
        >
          <Skeletons
            height={500}
            width={"100%"}
            style={{
              marginRight: 10,
              borderRadius: 10,
            }}
          />
        </View>
      )}
    </View>
  );
};

export default ChatSkeleton;
